<template>
  <div class="property-wrap">
    <div class="page-header">
      <el-select
        class="select-item"
        v-model="filterData.advertiserId"
        filterable
        :filter-method="filterCount"
      >
        <el-option label="全部广告账号" :value="-1"> </el-option>
        <el-option
          v-for="item of countList"
          :key="item.advertiserId"
          :value="item.advertiserId"
          :label="item.company + '-' + item.advertiserName"
        ></el-option>
      </el-select>
      <el-select class="select-item" v-model="filterData.appName" filterable>
        <el-option label="全部应用" :value="-1"> </el-option>
        <el-option
          v-for="item of appList"
          :key="item.id"
          :label="item.app_name + '（' + item.package_name + '）'"
          :value="item.app_name"
        >
        </el-option>
      </el-select>
      <el-select class="select-item" v-model="filterData.convertType">
        <el-option label="全部转化目标" :value="-1"></el-option>
        <el-option label="激活" value="AD_CONVERT_TYPE_ACTIVE"></el-option>
        <el-option label="行为" value="AD_CONVERT_TYPE_BEHAVIOR"></el-option>
        <el-option label="关键行为" value="AD_CONVERT_TYPE_GAME_ADDICTION"></el-option>
      </el-select>
      <el-button class="header-btn" @click="resetFilter" style="margin-left: auto">重置</el-button>
      <el-button class="header-btn" @click="searchData" type="primary">查询</el-button>
    </div>
    <div class="page-content">
      <div class="btn-list">
        <!-- <el-button
          class="btn-item"
          icon="el-icon-plus"
          type="primary"
          @click="addTransform"
          >新增应用转化</el-button
        >
        <el-button
          class="btn-item border-btn"
          type="primary"
          @click="batchDelete"
          ><svg-icon iconClass="pl" className="icon"></svg-icon
          >批量删除</el-button
        > -->
        <el-button class="btn-item border-btn" @click="snycConvert" type="primary" :loading="issnyc"
          ><svg-icon v-show="!issnyc" iconClass="tb" className="icon"></svg-icon
          >{{ issnyc ? "同步中" : "同步" }}</el-button
        >
      </div>
      <div class="table-wrap">
        <el-table
          :data="tableList"
          style="width: 100%"
          height="calc(100vh - 290px)"
          @selection-change="handleSelectionChange"
        >
          >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column prop="advertiser_name" label="广告账户名称"></el-table-column>
          <el-table-column prop="app_name" label="应用名称"></el-table-column>
          <el-table-column prop="package_name" label="应用包名"></el-table-column>
          <el-table-column prop="name" label="转化名称"></el-table-column>
          <el-table-column prop="convert_id" label="转化ID"></el-table-column>
          <el-table-column prop="convert_source_type" label="追踪方式">
            <template slot-scope="scope">
              {{
                scope.row.convert_source_type === "AD_CONVERT_SOURCE_TYPE_APP_DOWNLOAD"
                  ? "应用下载API"
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="convert_type" label="转化目标">
            <template slot-scope="scope">
              {{
                scope.row.convert_type === "AD_CONVERT_TYPE_ACTIVE"
                  ? "激活"
                  : scope.row.convert_type === "AD_CONVERT_TYPE_BEHAVIOR"
                  ? "行为"
                  : scope.row.convert_type === "AD_CONVERT_TYPE_GAME_ADDICTION"
                  ? "关键行为"
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="deep_external_action" label="深度转化目标">
            <template slot-scope="scope">
              {{ scope.row.deep_external_action == "0" ? "无" : "次日留存" }}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="checkTransform(scope.row)">详情</el-button>
              <!-- <el-button type="text" @click="push(scope.row)">推送</el-button>
              <el-button type="text" @click="deleteItem(scope.row)"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
        <div class="pro-pagination-wrap">
          <self-pagination
            :total="pageData.total"
            :pageSize="pageData.size"
            :currentPage="pageData.page"
            @getCurrentPage="changePage"
            @handleSizeChange="changePageSize"
          ></self-pagination>
        </div>
      </div>
    </div>
    <edit-modal @refreshList="searchData" ref="editModalRef"></edit-modal>
    <push-modal ref="pushModalRef"></push-modal>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import { getAdCount, getConvert_k, loadKuaishouConvert, deleteAdConvert } from "@/api/property.js";
import { getCommonProductList } from "@/api/api.js";
import EditModal from "./sub/editModal.vue";
import PushModal from "./sub/push.vue";
export default {
  name: "property",
  components: {
    SvgIcon,
    EditModal,
    PushModal,
  },
  data() {
    return {
      countList: [],
      copyCountList: [],
      appList: [],
      tableList: [],
      filterData: {
        advertiserId: -1,
        appName: -1,
        convertType: -1,
      },
      pageData: {
        page: 1,
        size: 10,
        total: 15,
      },
      issnyc: false, //是否同步中
      timer: null,
      multipleSelection: [],
    };
  },
  mounted() {
    this.initSelect();
    this.searchData();
  },
  methods: {
    initSelect() {
      getAdCount({
        platType: 3,
      }).then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
          this.copyCountList = JSON.parse(JSON.stringify(res.advertiseInfos));
        }
      });
      getCommonProductList({
        platType: 3,
      }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
    },
    formatParmas() {
      let parmas = {
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
      };
      for (let [key, value] of Object.entries(this.filterData)) {
        if (value !== -1 && value !== "") {
          parmas[key] = value;
        }
      }
      return parmas;
    },
    searchData() {
      let parmas = this.formatParmas();
      getConvert_k(parmas).then((res) => {
        if (res.code === "0000") {
          this.tableList = res.data.list;
          this.pageData.total = res.data.total;
        }
      });
    },
    resetFilter() {
      this.filterData.advertiserId = -1;
      this.filterData.appName = -1;
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    addTransform() {
      this.$refs.editModalRef.addTransform();
    },
    checkTransform(data) {
      this.$refs.editModalRef.checkTransform(data);
    },
    push(data) {
      this.$refs.pushModalRef.showTransferModal(data);
    },
    snycConvert() {
      this.issnyc = true;
      let parmas = {};
      if (this.filterData.advertiserId !== -1) {
        parmas.advertiserId = this.filterData.advertiserId;
      }
      loadKuaishouConvert(parmas).then((res) => {
        if (res.code === "0000") {
          this.issnyc = false;
          this.$message({
            message: "转化数据同步成功",
            type: "success",
          });
          this.searchData();
        }
      });
    },
    deleteItem(data) {
      this.$confirm("确定删除该转化数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAdConvert({ id: data.id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                type: "success",
                message: "转化删除成功!",
              });
              this.searchData();
            }
          });
        })
        .catch(() => {});
    },
    batchDelete() {
      if (this.multipleSelection.length <= 0) {
        this.$message({
          type: "warning",
          message: "请至少选择一条数据",
        });
      } else {
        this.$confirm("确定批量删除已选择的数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            deleteAdConvert({
              id: this.multipleSelection.map((item) => item.id).join(),
            }).then((res) => {
              if (res.code === "0000") {
                this.$message({
                  type: "success",
                  message: "转化删除成功!",
                });
                this.searchData();
              }
            });
          })
          .catch(() => {});
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    filterCount(value) {
      if (value) {
        this.countList = this.copyCountList.filter((item) => {
          return (
            (item.advertiserId + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.advertiserName + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.company + "").toLowerCase().indexOf(value.toLowerCase()) >= 0
          );
        });
      } else {
        this.countList = this.copyCountList;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.property-wrap {
  padding: 16px;
  .page-header {
    display: flex;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .select-item {
      margin-right: 24px;
    }
    .header-btn {
      padding: 5px 22px;
    }
  }
  .page-content {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .btn-list {
      display: flex;
      .btn-item {
        padding: 5px 18px;
        .icon {
          margin-right: 6px;
        }
        &.border-btn {
          color: rgba(24, 144, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(24, 144, 255, 1);
          background: rgba(255, 255, 255, 1);
        }
        .rotate {
          transition: rotating 2s linear infinite !important;
        }
      }
    }
    .table-wrap {
      margin-top: 16px;
      min-height: 300px;
      width: calc(100vw - 260px);
      .pro-pagination-wrap {
        height: 58px;
      }
    }
  }
}
</style>
